import { TokenlonEnv, ENV } from '~/constants/env'

export const getEnv = () => {
  const env = ENV.production
    ? TokenlonEnv.production
    : ENV.staging
    ? TokenlonEnv.staging
    : TokenlonEnv.development

  return env
}
